import styled from 'styled-components';

export const BannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 14px 50px;
  flex-direction: column;
  background-color: #eff0f0;
  margin: 6em 0 1em;
  position: relative;
  @media (max-width: 720px) {
    align-items: center;
    padding: 8px 14px 26px;
    display: ${(props) => (props.isAboutUsPage ? 'none' : '')};
  }
`;
export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
`;
export const TopFooterWave = styled.img`
    width: 100%;
    height: auto;
    position: absolute;
    background:${(props) => props.topBg};
    top: ${(props) => props.top};
    bottom: ${(props) => props.bottom};
    transform:${(props) =>
      props.bottomtrans ? 'none' : 'translate(0, -98%'} );
`;
export const TopFooterWaveSvg = styled.span`
    svg {
        width: 100%;
        height: auto;
        position: absolute;
        left:0;
        top: ${(props) => props.top};
        bottom: ${(props) => props.bottom};
        transform:${(props) =>
          props.bottomtrans ? 'none' : 'translate(0, -98%'} );  
        }
`;
export const GetMyloSection = styled.div`
  margin-right: 30px;

  @media (max-width: 720px) {
    margin-right: 4px;
  }
`;

export const GetMylo = styled.div`
  color: hsl(0deg, 0%, 0%, 60%);
  font-size: clamp(20px, 3vw, 26px);
  font-weight: 700;
  max-width: 240px;
`;

export const ScanToInstall = styled.span`
  font-size: 12px;
  padding-left: 10px;
  font-weight: 500;
  color: #000000d9;
`;

export const RaiseHappiness = styled.p`
  font-weight: 500;
  font-size: clamp(12px, 2vw, 13px);
  color: hsl(0deg 0% 0% / 60%);
  max-width: 240px;
  padding-top: 10px;
`;

export const QRCode = styled.img`
  margin-top: 10px;
  width: clamp(60px, 5vw, 100px);
  height: clamp(60px, 5vw, 100px);
`;

export const MobileImage = styled.img`
  width: 100%;
  max-width: 230px;
  height: auto;
`;
